module.exports = __webpack_public_path__ + "static/media/whitetwitterbird.9b1a41bb.png";